import { useCreateLead } from "./use-create-lead.hook";
import { detect } from 'detect-browser';
import { isMobile, isIOS } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from "../store";
import { useCallback } from "react";
import { EVENT_CLICK_WHATSAPP_BUTTON, SEND_PARAMS } from "../constants";
import { emitEvent } from "../event-emitter";
import { updateLead } from "../reducers/client/client.actions";
import { FormType } from "../enums/form-type.enum";

const browser = detect();

export interface IUseWhatsappFormParams {
	phone: string;
	text?: string;
	form_type: FormType;
	remove_lead_id?: boolean;
}


export const useWhatsappForm = (params: IUseWhatsappFormParams) => {
	const dispatch = useDispatch();
	const createLead = useCreateLead(params.form_type);
	let lead = useSelector((state: RootState) => state.client?.lead);
	var windowReference: Window | null = null;


	const goToWhatsapp = useCallback(async () => {
		emitEvent(EVENT_CLICK_WHATSAPP_BUTTON);
		let recievedLead = lead;

		dispatch(updateLead({ form_type: params.form_type }));
		emitEvent(SEND_PARAMS, { form_type: params.form_type });

		if (isIOS && browser?.name !== "firefox") windowReference = window.open();

		if (!recievedLead?._id) {
			recievedLead = await createLead({ phone: "in whatsApp" }); //функция должна вернуть лид и при последующих вызовах возвращать один и тот же лид, не создавая новых
			if (!recievedLead) throw new Error("no lead was created");
		}

		const url = getUrl(params, recievedLead._id);

		if (isIOS && windowReference) {
			windowReference.location.href = url;
			setTimeout(() => windowReference && windowReference.close(), 1000);
		} else window.open(url, '_blank');

		return recievedLead;
	}, [lead, windowReference, params, createLead]);

	return goToWhatsapp;
}

function getUrl(params: IUseWhatsappFormParams, lead_id?: string) {
	const url = `https://wa.me/${params?.phone}?text=${params?.text}`;
	if (params.remove_lead_id || !lead_id) {
		return url;
	} else {
		return `${url} Id: ${lead_id}`;
	}
}